<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" />
    <el-scrollbar wrap-class="scrollbar-wrapper">

      <el-menu
        :default-active="activeMenu"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <template v-for="(item,i) in filterRoutes" v-if="item.routes.length">
          <div :key="item.path" class="menu-title">{{ item.name }}</div>
          <sidebar-item v-for="(route, index) in item.routes" :key="item.name + index" :item="route" :base-path="route.path" />
        </template>

        <router-link v-show="help" to="/help/helpCenter" :class="{'menu-title':true,'active-menu':helpRoute}">帮助中心</router-link>

      </el-menu>
    </el-scrollbar>
    <div class="btn-zd" @click="$emit('zd')">
      折<br>叠<br>&lt;</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Logo },
  methods: {
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'routeGather'
    ]),
    routes() {
      return this.routeGather
    },
    help() {
      return this.routeGather.find(item => item.name == '帮助中心')
    },
    helpRoute() {
      return this.$route.path == '/help/helpCenter'
    },
    filterRoutes() {
      const filtObj = [
        {
          name: '订单中心',
          filt: ['订单管理', '订单审批', '数据报表', '审批管理'],
          routes: []
        },
        {
          name: '财务中心',
          filt: ['钱包', '对账单'],
          routes: []
        },
        {
          name: '个人中心',
          filt: ['账号设置', '收藏商品', '我的地址', '浏览记录'],
          routes: []
        },
        {
          name: '基础设置',
          filt: ['部门管理', '人员管理', '商品管理', '审批设置', '商品分类'],
          routes: []
        }

      ]

      this.routes.forEach(item => {
        for (let i = 0; i < filtObj.length; i++) {
          if (filtObj[i].filt.indexOf(item.name) > -1) {
            filtObj[i].routes.push(item)
            break
          }
        }
      })
      return filtObj
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss">
.menu-title {
  font-size: 16px;
  height: 44px;
  line-height: 44px;
  text-align: left;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  padding-left: 47px;
}

.btn-zd {
  position: absolute;
  top: 300px;
  font-size: 12px;
  right: 0;
  transform: translateY(-50%);
  font-family: monospace;
  width: 32px;
  background: #E9E9E9;
  padding: 10px 0;
  line-height: 18px;
  user-select: none;
  cursor: pointer;
  z-index: 9;
}
.active-menu{
  background-color: #E6E6E6 !important;
}
</style>
